// extracted by mini-css-extract-plugin
export default {"elementContainer":"ElementList_elementContainer__PDGFN"};